module.exports = __webpack_public_path__ + "static/media/marker.d260dc4c.svg";